import { Fetch } from 'src/adapters';

const api = {
  fetchServerInfo: async (): Promise<Response> => Fetch.post('server_info')
};

export default api;
